export default "__VITE_ASSET__4XfmZShZ__"